import MotionVariants from '../../models/motion/variants';

//

function _fromTopOrLeft(direction) {
  return ['left', 'top'].includes(direction);
}

function _getCoordinateName(direction) {
  const horizontal = ['left', 'right'].includes(direction);
  return horizontal ? 'x' : 'y';
}

function _getExitCoordinateValue({ direction, animationOffset }) {
  return `${_fromTopOrLeft(direction) ? '' : '-'}${animationOffset}`;
}

function _getInitialCoordinateValue({ direction, animationOffset }) {
  return `${_fromTopOrLeft(direction) ? '-' : ''}${animationOffset}`;
}

// Exports
// -------

export default function useSlideInOut({
  animationOffset = '3rem',
  delay,
  delayChildren = 0.25,
  direction = 'right',
  duration = 0.75,
  initialHeight = 'auto',
} = {}) {
  const coordinateName = _getCoordinateName(direction);

  //
  // Result

  return MotionVariants.parse(
    {
      [coordinateName]: _getInitialCoordinateValue({
        direction,
        animationOffset,
      }),
      height: initialHeight,
      opacity: 0,
    },
    {
      [coordinateName]: 0,
      height: 'auto',
      opacity: 1,
      transition: {
        ...(delay ? { delay } : { delayChildren }),
        [coordinateName]: {
          bounce: 0.15,
          duration,
          type: 'spring',
        },
        opacity: {
          duration: duration / 2,
        },
        staggerChildren: duration / 3,
      },
      zIndex: 1,
    },
    {
      [coordinateName]: _getExitCoordinateValue({
        direction,
        animationOffset,
      }),
      height: 'auto',
      opacity: 0,
      position: 'absolute',
      when: 'afterChildren',
      zIndex: 0,
    }
  );
}
